export type CoordinateSource = 'geocoded' | 'manual';

export interface LocationModel {
  locationId: number;
  locationType: string;
  locationStreetNumber: number;
  locationStreet?: string;
  locationStreetNumberAddition?: string;
  locationPostalCode: string;
  locationCity?: string;
  locationLatitude?: string;
  locationLongitude?: string;
  locationCountry?: string;
  /** How the stored pair was placed; null for a pair that was seeded and never placed. Single read only. */
  coordinateSource?: CoordinateSource | null;
  /** UTC instant the pair was last placed (single read only). */
  coordinateSetAt?: string | null;
  /** Metres between a manual pin and the geocode of the address, measured when it was placed. */
  coordinateOffsetM?: number | null;
  /** OID of the partner that owns this location. */
  partnerOid?: string;
  /** Name of the partner that owns this location. */
  partnerName?: string;
  customers: Customer[];
  /** Installation groups this location belongs to (present on the detail endpoint). */
  installationGroups?: LocationInstallationGroup[];
}

export interface LocationInstallationGroup {
  installationGroupOid: string;
  name: string;
}

export interface Customer {
  customerCity: string;
  customerCountry: string;
  customerName: string;
  customerPostalcode: string;
  customerStatus: string;
  partnerOid: string;
  customerImage: string;
}

export interface LocationResponseModel {
  locations: LocationModel[];
  numberOfItems: number;
}

export interface InstallationType {
  id: string;
  name: string;
}

export interface LocationPayloadModel {
  country?: string;
  deviceStatus?: string;
  installedDevices?: string;
  functionType?: string;
  streetName?: string;
  streetNumber?: string;
  streetNumberAddition?: string;
  city?: string;
  zipCode?: string;
  numberOfDevicesMin?: number;
  numberOfDevicesMax?: number;
  partnerOid?: string;
  address?: string;
}

export interface LocationFilterModel extends LocationPayloadModel {
  limit: number;
  offset: number;
}

export interface LocationCreation {
  street?: string;
  street_number: number;
  street_number_addition?: string;
  postalcode: string;
  city?: string;
  municipality?: string;
  country?: string;
  type?: string;
  remarks?: string;
  /** Optional installation groups to attach the new location to on creation. */
  installation_group_oids?: string[];
}

export interface LocationUpdateModel {
  street?: string;
  street_number: number;
  street_number_addition?: string;
  postalcode: string;
  city?: string;
  country?: string;
  remarks?: string;
  type?: string;
}

export interface LocationUploadResponseModel extends LocationCreation {
  /** Backend verification result per row: `'Ok'` when valid, otherwise a human-readable error message. */
  validation_status?: string;
  customerId?: string;
  /** Set by the bulk endpoint when called with `create=true` — the id of the newly created location. */
  locationId?: number;
}

export enum DeviceStatusEnum {
  Operational = 'Operational',
  InMaintenance = 'InMaintenance',
  NotInstalled = 'NotInstalled',
  Offline = 'Offline',
  Error = 'Error',
}

export enum LocationDetailTab {
  General,
  Company,
  Devices,
  Insights,
  Services,
}
